export default __webpack_public_path__ + "static/media/rose-theme.cdb7fa79.svg";